import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class LoginAuth implements CanActivate {
    constructor(private router: Router) {
    }

    canActivate() {
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/authentications/src/login.auth.ts